/* eslint-disable max-len */
module.exports = {
  // ================ TEXTS FOR SITE ELEMENTS ================
  p: {
    moredetailed: "Подробнее...",
    send: "Отправить",
    changetheme: "Сменить цветовую тему",
    usermenu: "Меню пользователя",
    userpage: "Параметры пользователя",
    userexit: "<i class='fa fa-sign-out'></i>&nbsp;Выйти",
    userlogin: "<i class='fa fa-sign-in'></i>&nbsp;Войти",
    gotoportal: "<i class='fa fa-share-square-o'></i>&nbsp;ПОРТАЛ GC-NN",
    usrexit: "Выйти",
    usrlogin: "Войти",
    fieldlogin: "Логин",
    fieldpass: "Пароль",
    buttonlogin: "Войти",
    authFormTitle: "Форма авторизации пользователя",
    userLoggedSuccess: "Вы успешно авторизовались",
    userLoggedFailed: "Ошибка авторизации",
    nullLoginOrPass: "Отсутствуют требуемые аргументы - login & pass",
    missingADhash: "Srvbg-server отклонил вашу авторизацию. Вы должны находиться во Внутренней сети. Вы забыли включить OpenVPN?",
    incorrectUserIP: "Несовпадение IP-адреса Авторизованного пользователя на Srvbg-server",
    redirection: "Перенаправление...",
    userLoggedError1: "Это была ",
    userLoggedError2: " попытка за последний час. Если вы отправите неправильные данные 5 раз, вы будете заблокированы!",
    userLoggedWarning: "После 5 попыток неудачной авторизации Вы будете заблокированы!",
    changelng: "Change language",
    banned: "Вы заблокированы!",
    attentionban: "Вы пока не заблокированы. Но если это случится, то только владелец сайта сможет исключить вас из черного списка.",
    noscript: "ДЛЯ РАБОТЫ САЙТА НЕОБХОДИМО РАЗРЕШИТЬ ВЫПОЛНЕНИЕ СКРИПТОВ",
    messagesent: "Сообщение отправлено",
    cantsendmessage: "Не могу отправить сообщение",
    contractornotfound: "Контрагент не найден",
    spmoduleoff: "Модуль SharePoint отключен администратором",
    vibermoduleoff: "Viber-модуль отключен администратором",
    emptystring: "Пустая строка",
    emptyarray: "Пустой массив",
    nophonenumbers: "Не указаны номера телефонов",
    noinn: "ИНН не указан",
    norecipients: "Нет получателей",
    incorrentfields: "Не все поля заполнены корректно",
    fileconversionerror: "Ошибка конвертации файла",
    qrcodenouri: "Не передан URI для кодировки QR-кода",
    chartnodata: "Не переданы данные для построения графика",
    noidbuildobj: "Не передан ID строительного объекта",
    viberBotOnSubscribe: `Привет! Я Вайбер-бот. Вы сможете получать от меня сообщения в Viber о текущих задачах и другие оповещения. 
     Но сначала мне нужно идентифицировать вас. Отправьте мне свой номер телефона в таком формате: +79100000000`,
    viberBotNeedSubscribe: "Сначала мне нужно идентифицировать вас. Отправьте свой номер телефона в таком формате: +79100000000",
    viberBotUnderstandOnlyTextMessages: "Извините. Я понимаю только текстовые сообщения",
    viberBotDummyAnswer: "Писать комменты в этот чат не нужно. Никто их все-равно не увидит. Чат работает только в одну сторону Bot -> Viber",
    viberBotIalreadyKnowYou: "Вы уже зарегистрированы в Viber-боте",
    userWithThisPhoneNotFound: "Пользователь с этим телефоном не найден в базе данных 'users'",
    viberBotHello1: "Привет, ",
    viberBotHello2: "! Ваш ID: ",
    viberBotHello3: ". Вы успешно подключились к этому чату и теперь будете получать сообщения от Viber-бота",
    errorPageTitle: "Ошибка на стороне сервера при попытке рендеринга страницы",
    tooltipServicesHeadLink: "Статья в нашей базе знаний"
  },
  // ================ IMAGES ================
  i: {
    programmerisworking: { title: "Программист работает над этим разделом сайта.", src: "/img/general/programmer-is-working.png" }
  },
  // ================ HEADER AND FOOTER ================
  header: {
    title: "Геоконтроль-НН",
    navlinks: {
      title: "Геоконтроль-НН",
      text: "Техническое сопровождение строительства",
      linkhome: "Главная",
      linkservices: "Наши услуги",
      linksubservices: [
        { text: "Лаборатория неразрушающего контроля", href: "/services/ndt" },
        { text: "Механические испытания", href: "/services/mex" },
        { text: "Строительная лаборатория", href: "/services/stroylab" },
        { text: "Геодезия, маркшейдерские работы", href: "/services/geodesy" }
      ],
      linkcontacts: "Контакты",
      phone: "8-800-505-65-45",
      email: "mail@gc-nn.com"
    }
  },
  prefootersms: {
    text1: "Возьми телефон и позвони нам!",
    text2: "Отправьте Вашу заявку e-mail:",
    phone: "8-800-505-65-45",
    email: "mail@gc-nn.com",
    text3: "Отправьте нам сообщение с помощью этой формы. Мы перезвоним вам или отправим ответ на ваш вопрос в Viber / WhatsApp / Telegram",
    formph1: "Ваше имя",
    formph2: "Ваш телефон +7...",
    formph3: "Введите здесь свой вопрос..."
  },
  footer: {
    linkprivacy: "Конфиденциальность",
    linkbacktotop: "Наверх",
    linkpresentation: "Наша презентация"
  },
  other: {
    geography: "География наших объектов"
  }
};
/* eslint-enable max-len */
